import { useI18n } from 'builder/hooks/useI18n'
import { Container, Title, LogosContainer, Logo, LogoImageContainer, LogoMobile } from './styles'
import ACCENTURE from './assets/accenture.svg'
import AMAZON from './assets/amazon.svg'
import AMEX from './assets/americanexpress.svg'
import APPLE from './assets/apple.svg'
import BOOKING from './assets/booking.svg'
import DHL from './assets/dhl.svg'
import KPMG from './assets/kpmg.svg'

export const Logos = () => {
  const { i18n } = useI18n()

  return (
    <Container>
      <Title>{i18n.t('builder.billing.logos.title')}</Title>
      <LogosContainer>
        <>
          <LogoImageContainer>
            <Logo src={BOOKING} />
          </LogoImageContainer>
          <LogoMobile src={BOOKING} />
        </>
        <>
          <LogoImageContainer>
            <Logo src={APPLE} />
          </LogoImageContainer>
          <LogoMobile src={APPLE} />
        </>
        <>
          <LogoImageContainer>
            <Logo src={DHL} />
          </LogoImageContainer>
          <LogoMobile src={DHL} />
        </>
        <>
          <LogoImageContainer>
            <Logo src={AMAZON} />
          </LogoImageContainer>
          <LogoMobile src={AMAZON} />
        </>
        <>
          <LogoImageContainer>
            <Logo src={AMEX} />
          </LogoImageContainer>
          <LogoMobile src={AMEX} />
        </>
        <>
          <LogoImageContainer>
            <Logo src={ACCENTURE} />
          </LogoImageContainer>
          <LogoMobile src={ACCENTURE} />
        </>
        <>
          <LogoImageContainer>
            <Logo src={KPMG} />
          </LogoImageContainer>
          <LogoMobile src={KPMG} />
        </>
      </LogosContainer>
    </Container>
  )
}
